export enum ButtonTypeEnum {
  PRIMARY = 'primary',
  PRIMARY_DARK = 'primary-dark',
  SECONDARY = 'secondary',
  WHITE = 'white',
}
